import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@api/client/apiClient';
import { queryKeys } from '@api/queryKeys';
import type { Order, OrderItem } from '../types';

interface CreateOrderInput {
  name: string;
  comment?: string;
  items: OrderItem[];
}

export function useCreateOrder() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: CreateOrderInput) => apiClient.post<Order>('/orders', input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.orders.all });
    },
  });
}
